module.exports = __webpack_public_path__ + "static/media/samehalfar.e6a6f208.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/samehalfar.webp
// module id = 885
// module chunks = 0